<div *ngIf="isEditable && item.isFirmwareVersionEditable && item.isFirmwareUpdateSupported">
    <mat-form-field fxFlex.sm="100" fxflex.xs="100" fxFlex.gt-sm="50" *ngIf="isLoaded">
        <mat-label>Firmware Version</mat-label>
        <mat-select [formControl]="firmwareVersionFormControl" (selectionChange)="updateFirmwareVersion()">
            <mat-option *ngFor="let currentVersion of firmwareVersions" [value]="currentVersion.version">
                {{ currentVersion.version | hardwareVersion }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-progress-spinner *ngIf="!isLoaded" color="accent" mode="indeterminate" diameter="20px"></mat-progress-spinner>
</div>
<span *ngIf="!isEditable || !(item.isFirmwareVersionEditable && item.isFirmwareUpdateSupported)">
    {{ item.embeddedVersion | hardwareVersion }}
</span>